import { Component, OnDestroy } from '@angular/core';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import moment, { Duration } from 'moment';
import { Constant } from 'src/constant';
import * as fromUploader from '@app/client/uploader/store/reducers';
import * as fromRoot from 'src/app/reducers';
import { Observable, Subscription } from 'rxjs';
import { UploaderStatus } from '@smash-sdk/uploader';
import { DeliveryType } from '@app/client/uploader/interfaces/transfer';
import { PrepareActions, UploadActions } from '@app/client/uploader/store/actions';
import { environment } from 'src/environments/environment';
import { getProtocolHostnameAndPort } from '@app/shared/helpers/location';
import packageJson from '../../../../../../../../../package.json';
import { EnvironmentActions } from '@app/core/actions';
@Component({
  selector: 'app-modal-size-premium',
  templateUrl: './modal-size-premium.component.html',
  styleUrls: ['./modal-size-premium.component.scss']
})
export class ModalSizePremiumComponent implements OnDestroy {
  status$: Observable<UploaderStatus>;
  uploadFormMode$: Observable<DeliveryType>;
  timer: Duration;
  timerFormat: string;
  interval: any;
  start: any;
  updatedTime: any;
  subscriptions: Subscription[] = [];
  constructor(
    private store: Store<fromUploader.State & fromRoot.State>,
    public ref: DialogRef,
    private translateService: TranslateService,
    private gtmService: GoogleTagManagerService,
  ) {
    this.store.dispatch(EnvironmentActions.CreateEventScitylana({
      event: {
        event: 'modalSizePremiumView',
        url: getProtocolHostnameAndPort(),
        referer: document.referrer,
        date: new Date().toISOString(),
        clientName: environment.clientName,
        clientVersion: packageJson.version,
      }
    }));
    this.status$ = this.store.select(fromUploader.getUploadStatus);
    this.uploadFormMode$ = this.store.select(fromUploader.getUploadFormMode);

    this.timer = moment.duration(this.ref.data.queue, 'seconds');
    this.start = moment();
    this.timerFormat = `${Math.floor(this.timer.asHours())}h ${this.timer.minutes()}min ${this.timer.seconds()}s`;
    this.interval = setInterval(() => {
      this.updatedTime = moment();
      const diff = this.updatedTime.diff(this.start);
      this.timer = moment.duration(this.ref.data.queue, 'seconds');
      this.timer = this.timer.subtract(Math.floor(diff / 1000), 'second');
      this.timerFormat = `${Math.floor(this.timer.asHours())}h ${this.timer.minutes()}min ${this.timer.seconds()}s`;
      if (this.timer.asMilliseconds() <= 0) {
        this.clearTimer();
      }
    }, 1000);

    // `enableClose: false` (set where this modal is opened) already keeps it open on
    // outside/backdrop clicks and Escape. We deliberately do NOT subscribe to
    // backdropClick$: clicking outside must neither close the modal nor emit an event —
    // the modal is dismissable only through its own close button (onCloseModal).
    this.subscriptions = [];
  }



  ngOnDestroy(): void {
    this.clearTimer();
    this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  clearTimer() {
    clearInterval(this.interval);
    this.timerFormat = null;
  }

  onUploadAnonymous() {
    this.trackEvent(Constant.eventGTM.CLICK_FREE_UPLOAD_MODAL_SIZE_PREMIUM);
    this.store.dispatch(UploadActions.UpdateAndResumeUpload());
    this.closeModal();
  }

  onCloseModal() {
    this.trackEvent(Constant.eventGTM.CLOSE_MODAL_SIZE_PREMIUM);
    // Closing this modal must actually cancel the queued attempt, not just hide the dialog --
    // otherwise the transfer keeps sitting Queued in the background and, if it naturally starts
    // while the user is back on prepare, prepare.component.ts's uploadStatus$ subscription
    // silently navigates to /send. CancelUpload is the same mechanism send.component.ts already
    // uses to abort an in-flight upload; it resets the SDK/status AND forces the step back to
    // PREPARE (upload.effects.ts#cancelUpload$), and is already proven (upload-cancel.test.ts) to
    // preserve the file selection and prepare-form state -- exactly what closing this modal
    // should do too.
    this.store.dispatch(UploadActions.CancelUpload());
    this.closeModal();
  }

  private trackEvent(event: string): void {
    this.gtmService.pushTag({ event, transfer_size: this.ref.data.transferSize });
  }

  closeModal() {
    this.store.dispatch(PrepareActions.HideModalSizePremium());
    this.clearTimer();
    this.ref.close();
  }

  goSubscribe($event: Event, url: string) {
    this.trackEvent(Constant.eventGTM.CLICK_SUBSCRIBE_MODAL_SIZE_PREMIUM);
    window.open(this.translateService.instant(url), '_blank', 'noopener');
    $event.preventDefault();
    $event.stopPropagation();
  }
}
